import { apiRequest } from '@scc/lib'
import { toApiDate } from '@/lib/api-date'
import type { DateRange } from '@/modules/shared/types'
import type { BlueprintCohort, BlueprintProductList } from '@/modules/blueprint/types'

export interface BlueprintRepository {
  /** Products in the window, ranked, each flagged with whether a cohort can be built. */
  getProducts(clientId: string, range: DateRange, cohortSize?: number): Promise<BlueprintProductList>
  getCohort(
    clientId: string,
    productId: string,
    range: DateRange,
    cohortSize?: number,
  ): Promise<BlueprintCohort>
}

export function createApiBlueprintRepository(): BlueprintRepository {
  return {
    async getProducts(clientId, range, cohortSize = 10) {
      const params = new URLSearchParams({
        start: toApiDate(range.from),
        end: toApiDate(range.to),
        cohortSize: String(cohortSize),
      })
      return apiRequest<BlueprintProductList>(`/analytics/blueprintProducts?${params.toString()}`, {
        headers: { 'X-Store-Id': clientId },
      })
    },

    async getCohort(clientId, productId, range, cohortSize = 10) {
      const params = new URLSearchParams({
        start: toApiDate(range.from),
        end: toApiDate(range.to),
        productId,
        cohortSize: String(cohortSize),
      })
      // Served by the generic analytics view route, so the view name is the path.
      return apiRequest<BlueprintCohort>(`/analytics/blueprintCohort?${params.toString()}`, {
        headers: { 'X-Store-Id': clientId },
      })
    },
  }
}

export const blueprintRepository = createApiBlueprintRepository()
